export default __webpack_public_path__ + "static/media/spaceship.d14f69f7.svg";